import script from "./BaseDateRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDateRangePicker.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDateRangePicker.vue?vue&type=style&index=0&id=35950229&lang=css"

const __exports__ = script;

export default __exports__